const getPixelRatioFromCanvas = (stageRef) => { return stageRef?.current?._pixelRatio || 1.00; };

export { getPixelRatioFromCanvas };